import http from "./http";
import { CHALLENGE } from "@/constants";
import { stripDataUri } from "@/utils/media";

/**
 * The three live JUD endpoints, one function each.
 *
 * These are pure: they take arguments and resolve to unwrapped data. They never read the
 * store or localStorage — callers (Vuex actions) pass what is needed and persist results.
 */

/**
 * The inbound token is base64-ish and arrives via the URL, so it must be encoded — but
 * `+`, `=` and `/` are meaningful to the backend and have to survive. Encode, then put
 * those three back.
 */
export function encodeInboundToken(token) {
  return encodeURIComponent(token || "")
    .replace(/%20/g, "+")
    .replace(/%3D/g, "=")
    .replace(/%2F/g, "/");
}

/**
 * Exchange the inbound URL token for a session.
 * @returns {Promise<{ id: string, accessToken: string }>}
 */
export function checkToken(token) {
  return http
    .post("/jud/check-token", { token: encodeInboundToken(token) })
    .then((response) => response.data.data);
}

/**
 * Ask the backend which phrase the user must read on camera.
 * @returns {Promise<{ challengeSequence: string }>}
 */
export function selectChallenge(selectedChallenge = CHALLENGE) {
  return http
    .post("/jud/select-challenge", { selectedChallenge })
    .then((response) => response.data.data);
}

/**
 * Submit the three artefacts.
 *
 * The media arrive as full data-URLs (the review screen renders the very same values as
 * <img>/<video> sources), so the `data:…;base64,` prefix is stripped here, at the request
 * boundary. The access token travels in the body — there is no Authorization header.
 *
 * @returns {Promise<{ status: string, trackingId: string }>}
 */
export function finalize({ face, signature, video, judAccessToken }) {
  return http
    .post("/jud/finalize", {
      face: stripDataUri(face),
      signature: stripDataUri(signature),
      video: stripDataUri(video),
      jud_access_token: judAccessToken,
    })
    .then((response) => response.data.data);
}
